import { Flex, Text } from '@chakra-ui/react';
import { ApplyFormContainer, ApplyFormLayout } from 'common/layouts/apply-form';
import { InfoField } from 'common/components/info-card';
import { formatDateToHumanDate } from 'common/utils/formDateToHumanTime';
import ClaimsPaymentSummaryCard from 'components/claims/claims-payment-summary';
import { claimStatusEnum } from 'common/utils/enums';
import ApplyContent from 'components/apply-shared/apply-content';
import ApplyTitle from 'components/apply-shared/apply-title';
import ApplyButtons from 'components/apply-shared/apply-buttons';

const Step3Confirmation = ({ claim, onReturnToClaim }) => {
  return (
    <div className='flex flex-col w-full h-full'>
      <ApplyTitle
        title='Claim Finalized Successfully'
        subtitle='Your claim has been finalized and payment has been processed.'
        buttons={
          <ApplyButtons
            onNextClick={onReturnToClaim}
            nextTitle='Return to Claim'
            isValid={true}
            moveOn={true}
            disableBack
          />
        }
      />

      <ApplyContent>
        <ApplyFormContainer>
          <ApplyFormLayout className='pb-6'>
            <Flex className='flex-col gap-2 col-span-2'>
              <Text className='font-medium text-lg col-span-2'>
                Finalized Claim Details
              </Text>
            </Flex>
            <InfoField title='Move Out Date'>
              {formatDateToHumanDate(claim?.submission?.confirmedDate)}
            </InfoField>
            <InfoField title='Finalized On'>
              {formatDateToHumanDate(
                claim?.statusChanges?.find(
                  (x) => x.status === claimStatusEnum.CONFIRMED
                )?.updatedAt
              )}
            </InfoField>
            <InfoField title='Review' className='col-span-2'>
              {claim?.review?.reason}
            </InfoField>            
          </ApplyFormLayout>

          <div className='col-span-2 py-6'>
            <ClaimsPaymentSummaryCard claim={claim} isComplete />
          </div>
        </ApplyFormContainer>
      </ApplyContent>
    </div>
  );
};

export default Step3Confirmation; 